"use client";

import { useHydrationSafeFeatureFlagEnabled } from "@/hooks/useHydrationSafeFeatureFlagEnabled";
import { isEuropeRegion } from "@/utils/common/region";

export const META_INTEGRATION_FLAG = "ui-meta-integration";

/**
 * Whether the Meta integration can be offered at all. Production-EU has no Meta
 * app (`META_APP_ID` is unset), so a connect there could only fail.
 */
export function useMetaIntegrationAvailable(): boolean {
  const flagEnabled = useHydrationSafeFeatureFlagEnabled(META_INTEGRATION_FLAG);
  return flagEnabled && !isEuropeRegion();
}
